export default {"src":"/kelp/_next/static/media/ggETH.5690e971.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};